import React from 'react';
import Product from '../product/product';
import SurveyBanner from '../banner/banner';
import './decision-tree.scss';
import stepsData from './data/root.js';

class DecisionTree extends React.Component {

    /**
     * Initialising the state to the root object when the application loads
     */
    state = {
        data: stepsData.root,
        nextStepData: "",
        checkedRadio: null,
        lastNode: false,
        suggestedProduct: null
    }

    render() {
        return this.renderDecisionTree()
    }
    /**
     * Takes user to the next question of the survey
     */
    goToNextStep = () => {
        this.setState({
            data: this.state.nextStepData,
            nextStepData: "",
            lastNode: !!this.state.nextStepData.lastNode,
            suggestedProduct: {
                "productName": this.state.nextStepData.productName,
                "productImageUrl": this.state.nextStepData.lastNodeImagePath,
                "productLink" : this.state.nextStepData.productLink,
                "productLinkText" : this.state.nextStepData.productLinkText
            }
        })

    }


    /**
     * Resets the survey and takes back user to root question
     */
    resetSurvey = () => {
        this.setState({
            data: stepsData.root,
            nextStepData: "",
            checkedRadio: null,
            lastNode: false,
            suggestedProduct: null
        })
    }

    /**
     * Called when the user selects a choice.
     * Loads the state with new values when user selects a choice
     */
    makeChoice = (event) => {

        if (!!event.currentTarget.value) {
            let selectedValue = event.currentTarget.value;
            this.setState({
                nextStepData: stepsData[selectedValue],
                checkedRadio: selectedValue
            })
            console.log(stepsData[selectedValue]);
        }
    }

    /**
     * Builds the list of radio Buttons Available as per data
     */
    renderChoices = () => {
        return (
            <div>
                {this.state.data.options.map((item, index) => (
                    <label className="custom-radio" key={index}>
                        <input type="radio" value={item.value} checked={this.state.checkedRadio === item.value} id="option1" name="choice" onChange={this.makeChoice} />
                        <span className="checkmark sm"></span>
                        {item.text}
                    </label>
                ))}
            </div>
        );
    }


    /**
     * Builds the decision tree 
     */
    renderLastNode() {
        return (
            <Product product={this.state.suggestedProduct} resetSurvey={this.resetSurvey}></Product>

        )
    }


    /**
     * Builds the decision tree 
     */
    renderDecisionTree = () => {
        if (!!this.state.lastNode) {
            return this.renderLastNode();
        } else {
            return (
                <div >
                    <SurveyBanner/>

                    <div className="mcq-row">
                        <div className="row">
                            <div className="col-sm-4">
                                <img src={this.state.data.imagePath} className="desc-img" alt="" />
                            </div>
                            <div className="col-sm-8">
                                <h4 className="hideClass">{this.state.data.header}</h4>
                                <h4>{this.state.data.question}</h4>
                                {this.renderChoices()}
                                <div className="btn-row"> 
                                    <button type="button" className="med-primary-button" onClick={this.goToNextStep} disabled={!!!this.state.nextStepData}>Next</button>
                                    <button type="button" className="med-secondary-button" onClick={this.resetSurvey}>Start Over</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

    }





}

export default DecisionTree